// @flow

const environmentLoader = {
    load: function(key: string) {
        return (typeof window !== 'undefined' && window.APP_STATE) ? (key ? window.APP_STATE[key] : window.APP_STATE) : undefined;
    }
};

export default environmentLoader;